import React, { FunctionComponent, useContext } from 'react'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import PropTypes from 'prop-types'
import Tooltip from '@material-ui/core/Tooltip'
import Slider from '@material-ui/core/Slider'
import { AiOutlineQuestionCircle } from 'react-icons/ai'

import '../styles/Settings.scss'
import { useInstantSearch } from '../App'

const CustomSwitch = withStyles({
  root: {
    width: 45,
    height: 36,
  },
  thumb: {
    width: 15,
    height: 15,
  },
  switchBase: {
    top: 5,
    padding: 5,
  },
})(Switch)

function ValueLabelComponent(props: any) {
  const { children, open, value } = props

  return (
    <Tooltip
      open={open}
      enterTouchDelay={0}
      placement='top'
      title={`${value}s`}
      arrow
    >
      {children}
    </Tooltip>
  )
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
}

const CustomToolTip = withStyles(() => ({
  tooltip: {
    maxWith: 150,
    fontSize: 12,
  },
}))(Tooltip)

const Settings: FunctionComponent = () => {
  const { variable: instantSearch, setVariable: setInstantSearch } = useContext(
    useInstantSearch
  )!

  const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInstantSearch({ ...instantSearch, isOn: e.target.checked })
  }

  const handleSliderChange = (value: number | number[]) => {
    setInstantSearch({ ...instantSearch, delay: value })
  }

  return (
    <div className='Settings'>
      <div className='Settings-toggle'>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={instantSearch.isOn}
              onChange={(e) => handleToggleChange(e)}
              color='primary'
              name='checkedB'
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          label='Instant Search'
        />

        <CustomToolTip
          title="Instant search will automatically populate search results when you've finished typing. Customize the delay time with the slider below."
          placement='top'
          arrow
        >
          <div className='Settings-toggle-info'>
            <AiOutlineQuestionCircle color='#535865' />
          </div>
        </CustomToolTip>
      </div>

      <div className='Settings-slider'>
        <FormLabel component='legend'>Delay:</FormLabel>
        <Slider
          ValueLabelComponent={ValueLabelComponent}
          aria-label='custom thumb label'
          defaultValue={0.7}
          step={0.1}
          min={0.5}
          max={2.0}
          onChangeCommitted={(e, value) => handleSliderChange(value)}
          disabled={!instantSearch.isOn}
        />
        <div className='Settings-slider-label'>
          <p>Faster</p>
          <p>Slower</p>
        </div>
      </div>
    </div>
  )
}

export default Settings
